export { default as ALIImageView } from "./ALIImageView"
export { default as ALITextView } from "./ALITextView"
export { default as ALIVideoView } from "./ALIVideoView"
export { default as ALICompanyFollowButton } from "./ALICompanyFollowButton"
// export { default as TextView } from "./TextView";
export { default as SeoLinearLayout } from "./SeoLinearLayout";
export { default as SeoFrameLayout } from "./SeoFrameLayout";
// CountDownView 占位（未实现，修复报错）
import * as Dinamic from '@ali/dinamic';
import { View } from '@ali/dinamic-views-icbu-fork';
Dinamic.registerView('CountDownView', View);